module.exports = __webpack_public_path__ + "static/img/2024 02.7a37b39a.png";